import { Component, inject, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@eredes/auth';
import { DSM34Dialog } from '@eredes/dsm34';

import { GlobalService } from '../../_core/services/global.service';
import { PwdService } from '../../_core/services/pwd.service';
import { EdpValidators } from '../../_shared/edp-validators/edp-validators';
import { GenericModalComponent } from '../../_shared/generic-modal/generic-modal.component';
import { ValidationRulesModalComponent } from '../../auth/validation-rules-modal/validation-rules-modal.component';

@Component({
  selector: 'app-user-recovery',
  templateUrl: './user-recovery.component.html',
  standalone: false,
})
export class UserRecoveryComponent implements OnInit {
  recoveryForm: UntypedFormGroup;
  invalidPwd = false;
  barArray: any[];
  pwdLabel = '';
  pwdType = 'password';
  pwdTypeConfirm = 'password';
  userAccount: string;
  validation = '';
  data: any;
  userNif: any;
  userEmail: any;
  id = '';
  token = '';

  private validatorPattern =
    /^(?!.*([A-Za-z0-9$#%@&=.+*()[\]{}:;\\<,\'.:\/_-])\1{2}).*(?=.{10,})(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\d])(?=.*[$#%@&=.+*()[\]{}:;\\<,\'.:\/_-]).*$/;

  public dialog = inject(DSM34Dialog);

  get f() {
    return this.recoveryForm.controls;
  }

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected authService: AuthService,
    protected fb: UntypedFormBuilder,
    protected pwdService: PwdService,
    protected globalService: GlobalService
  ) {}

  ngOnInit() {
    this.globalService.clearStorage();
    this.recoveryPassForm();
    this.barArray = this.pwdService.setBarColors(4, '#DDD', []);
    this.setIdToken();
  }

  protected setIdToken() {
    this.token = this.route.snapshot.params.token;
  }

  openRules() {
    this.dialog.open(ValidationRulesModalComponent, {
      disableClose: false,
    });
  }

  recoveryPassForm(data?) {
    this.recoveryForm = this.fb.group(
      {
        pwd: ['', [EdpValidators.required, EdpValidators.minLength(10), EdpValidators.pattern(this.validatorPattern)]],
        confirmPwd: [
          '',
          [EdpValidators.required, EdpValidators.minLength(10), EdpValidators.pattern(this.validatorPattern)],
        ],
      },
      {
        validator: EdpValidators.MatchPassword,
      }
    );
  }

  checkPwd(e: any) {
    const pwdStrength = this.pwdService.onChangePwd(e.target.value);
    this.pwdLabel = pwdStrength.label;
    this.barArray = pwdStrength.barArray;
    this.invalidPwd = pwdStrength.invalid ? true : false;
  }

  togglePwd() {
    this.pwdType === 'password' ? (this.pwdType = 'text') : (this.pwdType = 'password');
  }

  togglePwdConfirm() {
    this.pwdTypeConfirm === 'password' ? (this.pwdTypeConfirm = 'text') : (this.pwdTypeConfirm = 'password');
  }

  onRecoveryPassword() {
    const pwd = this.recoveryForm.value.pwd;
    const confirmPwd = this.recoveryForm.value.confirmPwd;

    this.authService.passwordSet(this.token, pwd, confirmPwd).subscribe(
      (result) => {
        if (result.Success) {
          this.getSuccessModal();
        } else {
          this.getErrorModal('Erro na definição de Password', result.Result);
        }
      },
      () => {
        this.getErrorModal('Erro na definição de Password', 'Ocorreu um erro. Por favor, tente mais tarde.');
      }
    );
  }

  protected getSuccessModal() {
    const confirmDialog = this.dialog.open(GenericModalComponent, {
      data: {
        modalTitle: 'Definição de Password',
        modalText: 'A sua password foi definida com sucesso!',
        btnConfirmText: 'OK',
        success: true,
      },
      disableClose: true,
    });
    confirmDialog.afterClosed().subscribe((result) => {
      this.router.navigate(['login']);
    });
  }

  /**
   * Trigger an modal pop-up error
   * @param title - to display
   * @param text - to display a description
   */
  protected getErrorModal(title: string, text: string) {
    const confirmDialog = this.dialog.open(GenericModalComponent, {
      data: {
        modalTitle: title,
        modalText: text,
        btnConfirmText: 'OK',
        error: true,
      },
      disableClose: true,
    });
    confirmDialog.afterClosed().subscribe((result) => {});
  }
}
